import React from 'react';
import { Container } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from '../../../helpers/intlMessage';

function Imuno ({ lista }) {

  function RenderizarFooter({ total, text }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <i className="mv-basico-stacktrace" style={{ fontSize: '20px', height: '-150px' }} />{' '}
          <span style={{ marginTop: '2px', fontSize: '14px' }} id="total-exames">
            {text}: {total} <IntlMessage id="dashboards.disposalMaterials.table.items"/>
          </span>
        </span>
      </div>
    );
  }

  return (
    <Container fluid className='mv-workspace-container  table-imuno-tarefas'>
      <DataTable
        value={lista}
        responsive={true}
        selectionMode='single'
        style={{ height: '100%' }}
        columnResizeMode='expand'
        scrollable={true}
        scrollHeight='71vh'
        scrollWidth='100%'
        resizableColumns={true}
        reorderableColumns={true}
        rowsPerPageOptions={[10, 20, 50]}
        lazy={false}
        paginator={false}
        emptyMessage={<IntlMessage id = "dashboards.taskControl.noResult"/>}
        footer={<RenderizarFooter text={'Total'} total={lista.length} />}
        alwaysShowPaginator={true}
        autoLayout={true}
        totalRecords={lista.length}
        onSelectionChange={e => {}}
      >
        <Column
          sortable={true}
          field='exame'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.exam"/>}
        />
        <Column
          sortable={true}
          field='bloco'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.block"/>}
        />
        <Column
          sortable={true}
          field='lamina'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.blade"/>}
        />
        {/* <Column
          sortable={true}
          field='nrExameAnterior'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.linkedExam"/>}
        /> */}
        <Column
          sortable={true}
          field='material'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.material"/>}
        />
        <Column
          sortable={true}
          field='tipoLamina'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.bladeType"/>}
        />

        <Column
          sortable={true}
          field='responsavel'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.pathologistDoctor"/>}
        />
        <Column
          sortable={true}
          field='prontuario'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.medicalRecord"/>}
        />
        {/* <Column
          sortable={true}
          field='datafinalizacaoFormated'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.dateCompleted"/>}
        /> */}
         <Column
          sortable={true}
          field='anticorposFormated'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.antibody"/>}
        />
        <Column
          sortable={true}
          field='anticorposFormated'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.antibody"/>}
        />
        <Column
          sortable={true}
          field='clone'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.clone"/>}
        />
        <Column
          sortable={true}
          field='especie'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.species"/>}
        />
        <Column
          sortable={true}
          field='finalizacao'
          style={{width: '110px',verticalAlign: 'middle'}}
          header={<IntlMessage id = "dashboards.taskControl.status"/>}
        />
      </DataTable>
    </Container>
  );
}

export default Imuno;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Imuno/index.js